import { render, staticRenderFns } from "./receipt-eft-details.vue?vue&type=template&id=bffdeb3e&scoped=true&lang=pug"
import script from "./receipt-eft-details.vue?vue&type=script&lang=js"
export * from "./receipt-eft-details.vue?vue&type=script&lang=js"
import style0 from "./receipt-eft-details.vue?vue&type=style&index=0&id=bffdeb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffdeb3e",
  null
  
)

export default component.exports